
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType118';
import { faCircleInfo } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import { isMobileOrTablet } from '@ads/utils/adx';
import dayjs from 'dayjs';

interface PoliticalAd {
  adId: string;
  campaignId: string;
  adStartDate: string;
  adEndDate: string;
  adFormat: string;
  adUrl: string;
  disclaimerUrl: string;
  adImage: string;
  clientName: string;
  clientControl: string;
  event: string;
}

type DeviceType = 'desktop' | 'mobile';

const defaultSettings = {
  config: [
    {
      adId: '',
      campaignId: '',
      adStartDate: '',
      adEndDate: '',
      adFormat: '',
      adUrl: '',
      disclaimerUrl: '',
      adImage: '',
      clientName: '',
      clientControl: '',
      event: '',
    },
  ],
};

const deviceVisibility: Record<DeviceType, string[]> = {
  desktop: ['1200x250', '880x250', '300x600'],
  mobile: ['300x250'],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  data() {
    return {
      faCircleInfo,
      deviceVisibility,
    };
  },
  computed: {
    isAdFree(): boolean {
      return this.$store?.getters['adForm/getIsAdFree'];
    },
    activeAd(): PoliticalAd | null {
      const now = dayjs();

      if (!Array.isArray(this.data?.config)) {
        return null;
      }

      const activeAds = this.data.config.filter((ad: PoliticalAd) => now.isAfter(dayjs(ad.adStartDate)) && now.isBefore(dayjs(ad.adEndDate)));

      return activeAds.length ? activeAds[Math.floor(Math.random() * activeAds.length)] : null;
    },

    isVisible(): boolean {
      const deviceType: DeviceType = isMobileOrTablet() ? 'mobile' : 'desktop';

      if (!this.activeAd?.adFormat) {
        return false;
      }

      return this.deviceVisibility[deviceType].includes(this.activeAd.adFormat);
    },

    imageDimmensions(): number[] {
      if (!this.activeAd?.adFormat) {
        return [0, 0];
      }

      const [width, height] = this.activeAd.adFormat.split('x').map(Number);

      return Number.isFinite(width) && Number.isFinite(height) ? [width, height] : [0, 0];
    },
  },
  methods: {
    handleClick(type: 'banner' | 'disclaimer'): void {
      const url = type === 'banner' ? this.activeAd?.adUrl : this.activeAd?.disclaimerUrl;

      this?.$event?.send('political_ad_click', {
        banner_id: this.activeAd?.adId,
        campaign_id: this.activeAd?.campaignId,
        type,
        url,
      });

      if (url) {
        window.open(url, '_blank');
      }
    },
  },
  mounted() {
    if (this.activeAd && this.isVisible && !this.isAdFree) {
      this?.$event?.send('political_ad_view', {
        banner_id: this.activeAd.adId,
        campaign_id: this.activeAd.campaignId,
      });
    }
  },
});
